<template>
  <div class="view" style="margin-top: 100px;">
    <div>
      <div class="container-lg container-fluid">
        <div class="page-title">
          <div class="row">
            <div class="col-6 d-flex"><h4>Dictionary</h4></div>
          </div>
          <div role="group" class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="icofont icofont-search"></i></div>
            </div>
            <input type="text" class="form-control" v-model="search">
          </div>
        </div>
      </div>
    </div>
    <div class="container-lg container-fluid mt-4">
      <div class="row">
        <div class="col-md-12">
          <div class="card" v-for="dic in dictionary" :key="dic.id">
            <div class="card-header"><h5>{{ dic.translation.en.name }}</h5>
            </div>
            <div class="card-body">
              <pre
                  style="white-space: pre-wrap;background: none;font-family: unset">{{
                  dic.translation.en.description
                }}</pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'DictionaryList',
  data() {
    return {
      search: ''
    }
  },
  computed: {
    dictionary: {
      get: function () {

        let dictionary = this.$store.getters['plan/getDictionary']

        let sorted = dictionary.sort((a, b) => (a.translation.en.name.toLowerCase() < b.translation.en.name.toLowerCase()) ? -1 : ((b.translation.en.name.toLowerCase() > a.translation.en.name.toLowerCase()) ? 1 : 0));

        if (this.search == '') return sorted

        return sorted.filter((item) => {
          return item.translation.en.name.toLowerCase().includes(this.search.toLowerCase())
        })
      },
    }
  },
  methods: {},
  created() {
    this.$store.dispatch('plan/loadDictionary')
  }
};
</script>
